
import React, { useState } from 'react';
import { KeyboardArrowRight } from '@material-ui/icons';

import Categories from '../generalComponents/Categories';
import useClickOutside from '../../hooks/useClickOutside';
import { useBlog } from '../../hooks/useBlog';


export const BlogSearchBar = ({ selectedCategoryId }) => {

  const { categories } = useBlog();

  const [showDropdown, setShowDropdown] = useState(false);

  const barRef = React.useRef(null);
  useClickOutside(barRef, () => {
    setShowDropdown(false);
  });

  const handleClick = (event) => {
    event.preventDefault();
    setShowDropdown(!showDropdown);
  };

  const categoryClick = (event) => {
    setShowDropdown(false);
  };

  const decideDisplayText = () => selectedCategoryId ? categories[selectedCategoryId] : 'All Posts';

  return (
    <nav ref={barRef} className="navbar" role="navigation">
      <ul className="nav">
        <li className="nav-item nav-title">Category:</li>
        <li className="nav-item nav-dd">
          <div className="dropdown">
            <a href="#" onClick={handleClick}>
              {decideDisplayText()}
              <KeyboardArrowRight fontSize="large" />
            </a>
            {showDropdown &&
            <Categories categories={categories} categoryClick={categoryClick} containerClass={'dropdown-menu'} />
            }
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default BlogSearchBar;
